import { render } from "./MicroWishDetailPage.vue?vue&type=template&id=066b8b9e&scoped=true"
import script from "./MicroWishDetailPage.vue?vue&type=script&lang=js"
export * from "./MicroWishDetailPage.vue?vue&type=script&lang=js"

import "./MicroWishDetailPage.vue?vue&type=style&index=0&id=066b8b9e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066b8b9e"]])

export default __exports__